<template>
    <div class="row">
        <div class="col-md-8">
            <i class="far fa-address-card mr-1"></i> {{ $t('general.nombre') }}
            <p class="">
                <strong>{{perito.nombre}}</strong>
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4" v-if="perito.telefono1">
            <i class="fas fa-phone-alt"></i> {{ $t('general.telefono') }}
            <p class="">
                <button type="button" v-on:click='llamar(perito.telefono1)'
                    class="btn btn-block btn-outline-info btn-sm">{{perito.telefono1}}</button>
            </p>
        </div>
        <div class="col-md-4" v-if="perito.movil1">
            <i class="fas fa-phone-alt"></i> {{ $t('general.movil') }}
            <p class="">
                <button type="button" v-on:click='llamar(perito.movil1)'
                    class="btn btn-block btn-outline-info btn-sm">{{perito.movil1}}</button>
            </p>
        </div>
        <div class="col-md-4" v-if="perito.email">
            <i class="fas fa-mail-bulk"></i> Email
            <p class="">
                <button type="button" @click="enviaremail(perito.email)"
                    class="btn btn-block btn-outline-info btn-sm">{{perito.email}}</button>
            </p>
        </div>
    </div>
    <div class="row">
        <div class="row">
            <div class="col-md-12">
                <strong> {{ $t('general.archivosdelperito') }}</strong>
                <div class="row" v-if="servicio.documentos">
                    <div class="col-md-4" v-for="archivos in servicio.documentos.perito" :key="archivos.id_documento" style="display: grid; gap: 5px;">
                        <div style="display: flex; justify-content: center;">
                            <Image
                                v-if="archivos.documento.substr(archivos.documento.length - 3) == 'jpg' || archivos.documento.substr(archivos.documento.length - 3) == 'png' || archivos.documento.substr(archivos.documento.length - 4) == 'jpeg' || archivos.documento.substr(archivos.documento.length - 3) == 'bmp' || archivos.documento.substr(archivos.documento.length - 3) == 'gif' || archivos.documento.substr(archivos.documento.length - 4) == 'tiff' || archivos.documento.substr(archivos.documento.length - 4) == 'webp'"
                                :src='archivos.url_completa_descarga' :id="archivos.id_documento" width="50"
                                :title="archivos.documento" preview :alt="archivos.documento" />
                            <a style="cursor: pointer;" v-else @click="descargarArchivos(archivos.url_completa_descarga)" :title="archivos.documento"
                                :alt="archivos.documento">
                                <i class="fas fa-file" style="font-size:50px;"></i>
                            </a>
                        </div>
                        <div style="display: flex; justify-content: center;">
                            <i title="Eliminar archivo" class="fas fa-times"
                            style="color:red;cursor:pointer;margin-top:4px"
                            @click="eliminararchivo(archivos.id_documento)"></i>&nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>  
import { PwgsApi } from '../../../../../services/PwgsApi';
import Image from 'primevue/image';

export default ({
        props: ['id', 'servicio','perito'],

    setup() {     
    },
    components: {
        Image,
    },
    data() {
        return {
            urlglobal: '',

        }
    },
    methods: {
        async eliminararchivo(idarchivo) {
            const api = new PwgsApi();
            //let subidadatos = { accion: 'eliminar' };
            if (confirm('¿Desea eliminar el archivo?')) {

                try {
                    await api.put('servicios/' + this.$props.id + '/accion-archivo/' + idarchivo +'?accion=eliminar');
                    this.$parent.$parent.$parent.cargarperito();
                    this.$parent.$parent.$parent.cargarmasdatos();
                    this.$parent.$parent.actualizar();
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        descargarArchivos(archivo) {
            let auxurlpdf = archivo;
            window.open(auxurlpdf,'_blank') 
        },
        llamar: function (telf) {
            window.open("tel:" + telf);
        },
        enviaremail(correo) {
            location.href = "mailto:" + correo;
        },
        cargarurl() {
            this.urlglobal = localStorage.getItem('direccion');
        },
    },
    mounted() {
        this.cargarurl();
    },
})


</script>